var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpMenuIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82.804,
    viewBox: "0 0 82 82.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#454f63;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.18 0.212)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.18 -0.212)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 82,
    height: 82.804
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.007 12.517)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.434,32h-.37a4.728,4.728,0,0,0-2.991,1.068L36.373,41a4.141,4.141,0,0,0-2.906-3.243l-8.986-2.7a12.653,12.653,0,0,0-3.637-.534h-.31a12.666,12.666,0,0,0-6.378,1.724L1.629,43.562A1.267,1.267,0,0,0,1,44.656V61.11a1.266,1.266,0,0,0,1.945,1.068l13.611-8.662H36.438a1.27,1.27,0,0,0,.818-.3L52.484,40.33A4.724,4.724,0,0,0,49.434,32Zm1.416,6.4L35.975,50.985H16.188a1.28,1.28,0,0,0-.68.2L3.531,58.805V45.383l11.9-6.942a10.147,10.147,0,0,1,5.1-1.378h.31a10.086,10.086,0,0,1,2.911.428l8.986,2.7a1.637,1.637,0,0,1-.472,3.2H23.782v2.531H33.907a1.269,1.269,0,0,0,.8-.286l12.968-10.61a2.2,2.2,0,0,1,1.388-.495h.37A2.193,2.193,0,0,1,50.85,38.4Z",
    transform: "translate(-1 -1.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.5,8.157a1.267,1.267,0,0,0-1.29.042L58.6,16.859H38.719a1.265,1.265,0,0,0-.818.3L22.673,30.044a4.725,4.725,0,0,0,3.05,8.332h.37a4.736,4.736,0,0,0,2.991-1.068l9.7-7.937a4.136,4.136,0,0,0,2.9,3.243l8.986,2.7a12.63,12.63,0,0,0,3.637.535h.31A12.662,12.662,0,0,0,61,34.12l12.527-7.308a1.263,1.263,0,0,0,.629-1.094V9.266A1.264,1.264,0,0,0,73.5,8.157ZM71.626,24.992l-11.9,6.941a10.136,10.136,0,0,1-5.1,1.38h-.31a10.135,10.135,0,0,1-2.911-.427l-8.986-2.7a1.638,1.638,0,0,1,.472-3.206h8.487V24.453H41.25a1.269,1.269,0,0,0-.8.286L27.483,35.348a2.2,2.2,0,0,1-1.39.5h-.37a2.193,2.193,0,0,1-1.416-3.867L39.182,19.391H58.969a1.269,1.269,0,0,0,.68-.2l11.977-7.622Z",
    transform: "translate(-4.6 -8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMenuIcn);
export default __webpack_public_path__ + "static/media/help_menu_icn.6e57adae591ddbe0cc2900c2b73db447.svg";
export { ForwardRef as ReactComponent };